/**
 * Pure helpers behind the list editing in the side panel: merging lists and
 * moving or deleting tickers. They work on the STORED lists (never the
 * type-filtered view) and return the lists that change, so the caller can save
 * exactly those.
 */

/** Alphabetical, the order the side panel shows a list's tickers in. */
export const sortedTickers = (tickers) => [...(tickers || [])].sort((a, b) => a.localeCompare(b));

/** `target` keeps its order; the `source` tickers it lacks follow, in their order. */
export function mergeTickers(target, source) {
  const have = new Set(target);
  const extra = [];
  for (const t of source) {
    if (!have.has(t)) { have.add(t); extra.push(t); }
  }
  return [...target, ...extra];
}

/** How many of `source` a merge would actually add to `target`. */
export const newTickerCount = (target, source) => mergeTickers(target, source).length - target.length;

/**
 * Take `tickers` out of `from` and put them in `to` (or, with `copy`, only put
 * them in `to`). Returns { changes: { name: tickers[] }, emptied: name | null }:
 * `emptied` is set when `from` would be left with nothing, which the server does
 * not accept as a list, so the caller decides what to do instead.
 */
export function moveTickers(lists, from, to, tickers, copy = false) {
  const moving = new Set(tickers);
  const changes = {};
  if (to && to !== from) changes[to] = mergeTickers(lists[to] || [], tickers);
  let emptied = null;
  if (!copy) {
    const rest = (lists[from] || []).filter(t => !moving.has(t));
    if (rest.length === 0) emptied = from; else changes[from] = rest;
  }
  return { changes, emptied };
}

/** `tickers` taken out of `list`; `emptied` as in moveTickers. */
export function removeTickers(lists, list, tickers) {
  return moveTickers(lists, list, null, tickers, false);
}
